var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-pay-result" }, [
    _vm.appName == "Vava"
      ? _c("div", { staticClass: "content" }, [
          _vm.status == "SUCCESS"
            ? _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/views/P1_Boys/PayResult/vava/pay_succ_vava.png"),
                  alt: "",
                },
              })
            : _vm._e(),
          _vm.status == "FAILED" || _vm.status == "CLOSED"
            ? _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/views/P1_Boys/PayResult/vava/pay_fail_vava.png"),
                  alt: "",
                },
              })
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.appName == "JoyChat"
      ? _c("div", { staticClass: "content" }, [
          _vm.status == "SUCCESS"
            ? _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/views/P1_Boys/PayResult/vava/pay_succ_joychat.png"),
                  alt: "",
                },
              })
            : _vm._e(),
          _vm.status == "FAILED" || _vm.status == "CLOSED"
            ? _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/views/P1_Boys/PayResult/vava/pay_fail_joychat.png"),
                  alt: "",
                },
              })
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }